import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { provideNgxMask } from 'ngx-mask';
import { CommonModule } from '@angular/common';
import { ParserHtmlPipe } from '../../parser-html.pipe';
import { OutsideClickDirective } from '../../outside-click.directive';

@Component({
    selector: 'app-confirm-request',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        ParserHtmlPipe,
        OutsideClickDirective
    ],
    templateUrl: './confirm-request.component.html',
    styleUrl: './confirm-request.component.scss',
    providers: [provideNgxMask()]
})
export class ConfirmRequestComponent {
  @Input() message!: string;
  @Input() inProcess!: boolean;
  @Input() userData!: any;
  @Input() isSuccess!: boolean;
  @Input() isResponse: boolean = false;
  @Input() showIcon = false;
  @Input() isHtml = false;
  @Input() deliveryMethod = '1';
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Input() txtCancelButton: string = 'Cancelar';
  @Input() txtConfirmButton: string = 'Guardar';
  @Input() hasButtons: boolean = false;
  isclose: boolean = false;

  constructor() {}

  cancelAction() {
    this.onCancel.emit();
    //window.location.reload()
  }

  confirmAction() {
    this.onConfirm.emit(this.deliveryMethod);
    //window.location.reload()
  }

  clickOutside(isOut: any) {

    if(!this.hasButtons){
      if (isOut) {
      this.cancelAction();
    }
    //this.isclose = true;
  }
  }
}
